import React from 'react';
import { View } from 'react-native';
import { Subtitle, Text } from 'app/src/styles';
import { useTranslation } from 'react-i18next';

import ExternalLink from 'app/src/elements/ExternalLink';

import ES from './ES/About';

const About = () => {
  const { i18n } = useTranslation();

  if ('es' === i18n.language) { return <ES />; }

  return (
    <View>
      <Text>
       oklahomatemptag.com is a portal for licensed Oklahoma auto dealers to
        pre-register vehicle sales in accordance with SB2035, also known as
        The Mason Treat Act. For more information on Pre-Registration or if you
        are a consumer, please visit:{' '}
        <ExternalLink url="http://readysettag.com">
          <Text>ReadySetTag.com</Text>
        </ExternalLink>
      </Text>
    </View>
  );
};

export default About;
